import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { CoreModule } from 'app/core/core.module';
import { AUDIT_ROUTES } from './audit.routing';
import { AuditListComponent } from './component/audit-list/audit-list.component';
import { AddAuditComponent } from './component/add-audit/add-audit.component';
import { AuditDetailsComponent } from './component/audit-details/audit-details.component';
import { AuditService } from './services/audit.service';
import { AuditModuleListComponent } from './component/audit-module-list/audit-module-list.component';
import { AuditModuleAddComponent } from './component/audit-module-add/audit-module-add.component';
import { AuditTypeListComponent } from './component/audit-type-list/audit-type-list.component';
import { AddAuditTypeComponent } from './component/add-audit-type/add-audit-type.component';

@NgModule({
	imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(AUDIT_ROUTES)
	],
    declarations: [
        AuditListComponent,
        AddAuditComponent,
        AuditDetailsComponent,
        AuditModuleListComponent,
        AuditModuleAddComponent,
        AuditTypeListComponent,
        AddAuditTypeComponent
    ],
	providers: [AuditService]
})
export class AuditModule { }
